import { render, staticRenderFns } from "./WorkloadForm.vue?vue&type=template&id=2faa177e&scoped=true&"
import script from "./WorkloadForm.vue?vue&type=script&lang=js&"
export * from "./WorkloadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faa177e",
  null
  
)

export default component.exports